import * as React from "react";
import styled from "styled-components";
import { useSpring, animated } from "react-spring";
import { Link } from "../../shared/Link";
import { toREM, toVWDesktop } from "../../../helpers/styles";
import * as CommonHeaderTypes from "../types";

export type DrawerSubMenuItemProps = {
  className?: string;
  onClick: (subMenuItem: CommonHeaderTypes.SubMenuItem) => void;
  subMenuItem: CommonHeaderTypes.SubMenuItem;
  active: boolean;
};

const DrawerSubMenuItem = ({
  className,
  onClick,
  active,
  subMenuItem,
}: DrawerSubMenuItemProps) => {
  const styles = useSpring({
    from: { width: "0%" },
    to: { width: active ? "100%" : "0%" },
  });
  if (!subMenuItem) return;

  const hasLink = "link" in subMenuItem && !!subMenuItem.link;
  const hasOptions =
    "options" in subMenuItem &&
    Array.isArray(subMenuItem.options) &&
    subMenuItem.options.length > 0;

  return (
    <Container
      className={className}
      active={active}
      data-drawer-submenu-trigger={hasOptions ? "true" : undefined}
      onClick={(event: React.MouseEvent<HTMLAnchorElement>) => {
        if (!hasLink) {
          event.preventDefault();
        }
        onClick(subMenuItem);
      }}
      onMouseEnter={() => onClick(subMenuItem)}
      onFocus={() => onClick(subMenuItem)}
      role={!hasLink ? "button" : undefined}
      aria-haspopup={hasOptions ? "menu" : undefined}
      aria-expanded={hasOptions ? active : undefined}
      to={hasLink ? subMenuItem.link : "#"}
    >
      {subMenuItem.label}
      {active && <Bar style={styles} />}
    </Container>
  );
};
const Bar = styled(animated.div)`
  height: 3px;
  background-color: var(--color-alt-green-03);
`;

const Container = styled(Link)<{ active?: boolean }>`
  cursor: pointer;
  border: none;
  background-color: transparent;
  color: ${(props) =>
    props.active ? "var(--color-black)" : "var(--color-green-100)"};
  font-family: ${(props) => props.theme.fontFamily},
    ${(props) => props.theme.fallBackFontFamily}, sans-serif;
  font-size: ${toREM(16)}rem;
  font-weight: 800;
  letter-spacing: 0;
  margin-top: ${toVWDesktop(7)}vw;
  margin-bottom: ${toVWDesktop(7)}vw;
  min-height: ${toREM(25)}rem;
  text-transform: uppercase;
  width: fit-content;
  text-decoration: none;

  &:focus-visible {
    outline: 1px solid var(--color-black);
    outline-offset: 2px;
  }
`;

export default DrawerSubMenuItem;
